import { createFileRoute } from "@tanstack/react-router";
import AdminGuides from "@/pages/admin/AdminGuides";

export const Route = createFileRoute("/_adminLayout/admin/guides")({
  component: AdminGuides,
});
